import { Quote } from 'lucide-react';

interface HowCitationProps {
  quote: string;
  attribution?: string;
  videoRef?: string;
}

export default function HowCitation({ quote, attribution, videoRef }: HowCitationProps) {
  return (
    <div className="relative my-4 overflow-hidden rounded-lg border border-gray-100 bg-gray-50 px-5 py-4">
      <div className="absolute bottom-0 left-0 top-0 w-1 bg-how-accent-warm" />

      <div className="pl-4">
        <Quote className="mb-3 h-5 w-5 text-how-accent-warm" />

        <blockquote className="text-[15px] leading-7 text-how-space-deep">
          {quote}
        </blockquote>

        {attribution && (
          <p className="mt-3 text-sm font-medium text-gray-500">
            - {attribution}
          </p>
        )}

        {videoRef && (
          <p className="mt-2 text-xs text-how-accent-warm">
            Ref: {videoRef}
          </p>
        )}
      </div>
    </div>
  );
}
